import React, { useEffect, useState } from "react";
import './answercontrol.css';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


export default function InternAnswers() {
  const [config, setConfig] = useState(null);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [answers, setAnswers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // For Popup
  const [marksSecured, setMarksSecured] = useState("");
  const [remarks, setRemarks] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [searchTerm, setSearchTerm] = useState("");




  const openPopup = (index) => {
  setCurrentIndex(index);
  setShowPopup(true);
  setMarksSecured(""); 
};

  const closePopup = () => {
  setShowPopup(false);
};


  const goPrev = () => {
  if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
};

const goNext = () => {
  if (currentIndex < answers.length - 1) setCurrentIndex(currentIndex + 1);
};

  // Load config
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error(err));
  }, []);

  // Fetch batches
  useEffect(() => {
    if (!config) return;

    const fetchBatches = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.GET_BATCHES}`);
        const data = await res.json();
        if (data.success) setBatches(data.batches);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBatches();
  }, [config]);

  // Fetch slots when batch changes
    useEffect(() => {
    if (!selectedBatch || !config) return;

    const batchName = batches.find(
      b => String(b.batch_id) === String(selectedBatch)
    )?.batch_name;

    if (!batchName) return;

    const fetchSlots = async () => {
      try {
        const res = await fetch(
          `${config.BASE_URL}${config.FETCH_SLOTS_BY_BATCH}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              batch_name: batchName,
            }).toString(),
          }
        );

        const data = await res.json();
        if (data.success) {
          setSlots(data.slots);
        } else {
          setSlots([]);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchSlots();
  }, [selectedBatch, batches, config]);


  useEffect(() => {
  if (!selectedSlot || !selectedBatch || !config) return;

  const fetchQuestions = async () => {
    try {
      const batchName = batches.find(
        b => String(b.batch_id) === String(selectedBatch)
      )?.batch_name;

      const res = await fetch(
        `${config.BASE_URL}${config.FETCH_ASSIGNED_QUESTIONS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            batch_name: batchName,
            slot_no: selectedSlot,
          }).toString(),
        }
      );

      const data = await res.json();

      if (data.success) {
        setQuestions(data.questions);
      } else {
        setQuestions([]);
      }

      setAnswers([]); 
      setSelectedQuestion("");

    } catch (err) {
      console.error(err);
    }
  };

  fetchQuestions();
}, [selectedSlot, selectedBatch, batches, config]);



useEffect(() => {
  if (!selectedQuestion || !selectedSlot || !selectedBatch || !config) return;

  const fetchAnswers = async () => {
    setIsLoading(true);
    try {

      const batchName = batches.find(
        b => String(b.batch_id) === String(selectedBatch)
      )?.batch_name;

      const res = await fetch(
        `${config.BASE_URL}${config.FETCH_ANSWERS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            batch_name: batchName,
            slot_no: selectedSlot,
            assignment_id: selectedQuestion
          }).toString(),
        }
      );

      const data = await res.json();

      if (data.success) {
        setAnswers(data.answers);
      } else {
        setAnswers([]);
      }

    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  fetchAnswers();
}, [selectedQuestion, selectedSlot, selectedBatch, batches, config]);




  const submitMarks = async () => {
  if (!marksSecured) {
    alert("Please enter marks");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("intern_id", current.intern_id);
    formData.append("assignment_id",current.assignment_id);
    formData.append("marks_secured", marksSecured);
    formData.append("remark", remarks);
    formData.append("total_marks", current.total_marks);

    const res = await fetch(`${config.BASE_URL}${config.SUBMIT_MARKS}`, {
      method: "POST",
      body: formData
    });

    const data = await res.json();

    if (data.success) {

      setAnswers((prev) => {
        const updated = [...prev];
        updated[currentIndex].Total_marks = marksSecured;
        updated[currentIndex].remarks = remarks; 
        return updated;
      });

      alert("Marks updated successfully!");
      // setShowPopup(false);
      setMarksSecured("");
      setRemarks("");
    } else {
      alert(data.message || "Failed to update marks");
    }

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};


  const current = answers[currentIndex];

  const filteredAnswers = answers.filter((a) =>
  a.intern_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  a.intern_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  a.intern_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  a.intern_mobile?.toLowerCase().includes(searchTerm.toLowerCase())
);


const downloadExcel = () => {
  if (answers.length === 0) {
    alert("No data to export");
    return;
  }

  const exportData = answers.map((a) => ({
    "Intern ID": a.intern_id,
    "Name": a.intern_name,
    "Email": a.intern_email,
    "Mobile": a.intern_mobile,
    "Question": a.question_name,
    "Submitted At": a.submitted_at,
    "Total Marks": a.total_marks,
    "Marks Secured": a.marks_secured,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Intern Answers");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array"
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream"
  });

  saveAs(blob, "Intern_Answers.xlsx");
};


  return (
    <div className="intern-answers-container">
      <h2 className="intern-answers-title">View Submitted Intern Answers</h2>

      <div className="intern-answers-dropdowns">
        <div className="dropdown-group">
          <label className="dropdown-label">Batch:</label>
          <select
            className="dropdown-select"
            value={selectedBatch}
            onChange={e => { setSelectedBatch(e.target.value); setSelectedSlot(""); setAnswers([]); }}
          >
            <option value="">Select Batch</option>
            {batches.map(b => (
              <option key={b.batch_id} value={b.batch_id}>{b.batch_name}</option>
            ))}
          </select>
        </div>

        {slots.length > 0 && (
          <div className="dropdown-group">
            <label className="dropdown-label">Slot:</label>
            <select
              className="dropdown-select"
              value={selectedSlot}
              onChange={e => setSelectedSlot(e.target.value)}
            >
              <option value="">Select Slot</option>
              {slots.map(s => (
                <option key={s.slot_no} value={s.slot_no}>{s.slot_no}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      {questions.length > 0 && (
        <div className="dropdown-group">
          <label className="dropdown-label">Question:</label>
          <select
            className="dropdown-select"
            value={selectedQuestion}
            onChange={e => setSelectedQuestion(e.target.value)}
          >
            <option value="">Select Question</option>
            {questions.map(q => (
              <option key={q.assignment_id} value={q.assignment_id}>
                {q.question_name}
              </option>
            ))}
          </select>
        </div>
      )}


      {isLoading && <p className="loading-text">Loading answers...</p>}
      {!isLoading && selectedQuestion && answers.length === 0 && (
  <p className="no-answers-text">No answers submitted for this question.</p>
)}


      {answers.length > 0 && (
        <div className="answers-table-container">
          <input
              type="text"
              placeholder="Search by ID, Name, Email or Mobile..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                marginBottom: "15px",
                padding: "8px",
                width: "300px",
                borderRadius: "6px",
                border: "1px solid #ccc"
              }}
            />
            <button
              onClick={downloadExcel}
              style={{
                marginLeft: "15px",
                padding: "8px 12px",
                backgroundColor: "#28a745",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer"
              }}
            >
              Download Excel
            </button>


          <h3 className="answers-table-title">Submitted Answers:</h3>

          <table className="answers-table">
            <thead>
              <tr>
                <th>Intern ID</th>
                <th>Name</th>
                <th>Image</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Question Name</th>
                <th>Submitted At</th>
                <th>Total Marks</th>
                <th>Marks Secured</th>
              </tr>
            </thead>
            <tbody>
              {filteredAnswers.map((a, idx) => (
                <tr key={idx}>
                  
                 <td 
                className="clickable-id"
                onClick={() => openPopup(idx)}
                style={{ cursor: "pointer", color: "#0a7cff", fontWeight: "bold" }}
                >
                {a.intern_id}
                </td>


                  <td>{a.intern_name}</td>
                  <td>
                    {a.intern_image ? (
                      <img src={`/temp_media/intern_profile_images/${a.intern_image}`} alt="intern" style={{ width: '50px', borderRadius: '50%' }} />
                    ) : "-"}
                  </td>
                  <td>{a.intern_email}</td>
                  <td>{a.intern_mobile}</td>
                  <td>{a.question_name}</td>
                  <td>{a.submitted_at}</td>
                  <td>{a.total_marks}</td>
                  <td>{a.marks_secured}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ---------------- POPUP MODAL ---------------- */}
      {showPopup && current && (
  <div className="popup-overlay">
    <div className="popup-box">
      
      <button className="close-btn" onClick={closePopup}>×</button>

      <div className="popup-header">
        <img 
          src={current.intern_image ? `/temp_media/intern_profile_images/${current.intern_image}` : ""}
          className="popup-image"
          alt="intern"
        />
        <h2>{current.intern_name}</h2>
        <p style={{ fontSize: "14px", opacity: 0.7 }}>{current.intern_id}</p>
      </div>

   <div className="popup-section" style={{ textAlign: "left" }}>
  <h3>Question</h3>
  <p><strong>{current.question_name}</strong></p>

  {/* Images + Video Container */}
  <div className="question-media" style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px", alignItems: "flex-start" }}>
    
    {/* Images */}
    {[current.image1, current.image2, current.image3, current.image4].map((img, idx) =>
      img ? (
        <img
          key={idx}
          src={`/Assignment_images/${current.assignment_id}/${img}`}
          alt={`Question Image ${idx + 1}`}
          style={{ maxWidth: "150px", borderRadius: "6px" }}
        />
      ) : null
    )}

    {/* Video */}
    {current.video && (
      <video controls style={{ maxWidth: "300px", borderRadius: "6px" }}>
        <source src={`/Assignment_images/${current.assignment_id}/${current.video}`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    )}
  </div>

  {/* Question Text */}
  <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", background: "#f8f8f8", padding: "10px", borderRadius: "6px", marginTop: "10px",textAlign: "left" }}>
    {current.question || "-"}
  </pre>
</div>



      <div className="popup-section" style={{ textAlign: "left" }}>
        <h3>Answer</h3>
        <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", background: "#f8f8f8", padding: "10px", borderRadius: "6px" }}>
            {current.answer || "-"}
        </pre>
        </div>


      {current.file && (
        <div className="popup-section">
          <h3>Submitted File</h3>
          <a 
            href={`/temp_media/submitted_answers/${current.batch_name}/${current.slot_no}/${current.intern_id}/${current.file}`}
            download={current.file}
            className="file-link"
          >
            Download File
          </a>
        </div>
      )}

      <div className="popup-section">
        <h3>Total Marks</h3>
        <p>{current.total_marks}</p>
      </div>

      <div className="popup-section">
        <h3>Enter Marks Secured</h3>
        <input 
        type="number"
        placeholder="Enter marks..."
        className="marks-input"
        value={marksSecured}           
        onChange={(e) => setMarksSecured(e.target.value)}  
        />

        <div className="popup-section">
      <h3>Remarks (Optional)</h3>
      <textarea
        placeholder="Enter remarks..."
        className="remarks-input"
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        rows={3}
        style={{
          width: "100%",
          padding: "8px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          resize: "vertical",
          marginTop: "5px"
        }}
      ></textarea>
    </div>

        <button className="ans-submit-btn" onClick={submitMarks}>
            Submit Marks
        </button>
      </div>


      <div className="popup-navigation">
        <button 
          className="nav-btn" 
          disabled={currentIndex === 0}
          onClick={goPrev}
        >
          ⟵ Previous
        </button>

        <button 
          className="nav-btn"
          disabled={currentIndex === answers.length - 1}
          onClick={goNext}
        >
          Next ⟶
        </button>
      </div>

    </div>
  </div>
)}
  </div>
  );
}
